import { ChangeDetectorRef, Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BulenoxAds, SponsoredAdsService } from '../../services/sponsored-ads.service';

@Component({
  selector: 'app-layout',
  standalone: false,
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  ads!: BulenoxAds;

  constructor(
    public router: Router,
    private sponsoredAds: SponsoredAdsService,
    private cdr: ChangeDetectorRef,
  ) {}

  async ngOnInit(): Promise<void> {
    this.ads = await this.sponsoredAds.get();
    this.cdr.detectChanges();
  }

  // Data-heavy pages that should use the whole window (no side ads, no centred column) -- like a trading platform.
  @HostBinding('class.layout-full')
  get fullWidth(): boolean {
    return ['/journal', '/admin', '/employee', '/insights', '/gamma-desk', '/options-desk', '/QQQ-Options-Strategies', '/stocks-desk', '/market-breadth', '/algo-desk'].some(prefix => this.router.url.split(/[?#]/)[0] === prefix || this.router.url.startsWith(prefix + '/'));
  }

  // Pages that keep the centred column but show no sponsored ads (side panels and the small-screen strip).
  @HostBinding('class.layout-no-ads')
  get noAds(): boolean {
    const [path, query = ''] = this.router.url.split('#')[0].split('?');
    const trialRequest = path.startsWith('/request-access') && /(^|&)trial=1(&|$)/.test(query);
    return path === '/contact-us' || trialRequest;
  }

  hideFooter(): boolean {
    const hidePrefixes = ['/ninja', '/request-access'];
    return hidePrefixes.some(prefix => this.router.url.startsWith(prefix));
  }
}
